import { cliente } from '@/lib/cliente';
import type { PeriodoMaqSel } from '@/lib/cliente';
import { useQuery } from '@tanstack/react-query';

/** Líneas de gasto de una máquina (drill-down de la columna Gasto). */
export function useMaquinariaGastoDetalle(maquina: string | null, periodoMaq?: PeriodoMaqSel) {
  return useQuery({
    queryKey: ['maquinaria-gasto-detalle', maquina, periodoMaq],
    queryFn: () => cliente.maquinaria.gastoDetalle(maquina!, periodoMaq),
    enabled: !!maquina,
  });
}
